
import {
  Component, Inject, Prop, Vue,
} from 'nuxt-property-decorator'
import { FSXARichText } from 'fsxa-pattern-library'
import { RichTextElement } from 'fsxa-api'
import ITextImage from '../shared/general/interfaces/ITextImage'
import IImageVideoContent from '../shared/general/interfaces/IImageVideoContent'
import { openLightbox } from '../shared/general/services/LightboxService'
import BaseGridLayout from './layouts/BaseGridLayout.vue'

@Component({
  name: 'TextImage',
  components: {
    BaseGridLayout,
    'rich-text': FSXARichText,
    BaseImageVideo: () => import('./ImageVideo/BaseImageVideo.vue'),
    BaseHeadline: () => import('./base/BaseHeadline.vue'),
    ShieldHalf: () => import('./svgs/ShieldHalf.vue'),
    Triangles: () => import('./svgs/Triangles.vue'),
  },
})
export default class TextImage extends Vue {
  @Prop() media ?: ITextImage

  @Prop() toggleGap ?: boolean

  @Prop({ required: true }) content! : RichTextElement[]

  @Prop({ required: true }) alignment! : 'left' | 'right' | 'centered'

  @Prop({ default: '' }) headline! : string

  @Prop({ default: '' }) introText! : string

  @Prop({ default: false }) displayDekraShield! : boolean

  @Prop({ default: null }) type ?: string | null

  @Inject({ default: '1' }) containerColumns ?: '1' | '2' | '3'

  private get imageVideoAlignment () : string {
    if ((!this.containerColumns || this.containerColumns === '1') && this.alignment === 'left') {
      return 'w-full md:float-left md:w-1/2 md:mr-6'
    }
    if ((!this.containerColumns || this.containerColumns === '1') && this.alignment === 'right') {
      return 'w-full md:float-right md:w-1/2 md:ml-6'
    }

    return 'w-full mx-auto'
  }

  private get mirrorTriangles () : boolean {
    return this.alignment === 'left'
  }

  private get mirrorTrianglesStyle () : string {
    return this.mirrorTriangles ? 'transform -scale-x-100' : ''
  }

  private showLightbox (content : IImageVideoContent) : void {
    if (!this.media?.lightbox && this.media?.mediaType !== 'video') return

    openLightbox(content)
  }

  private get showTriangles () : boolean {
    return !this.media && this.type === 'triangles'
  }

  private get alignmentCentered () : boolean {
    return this.alignment === 'centered'
  }

  private get marginToShield () : string {
    if (!this.displayDekraShield) return ''
    // the centered image is large with a bigger shield (it requires a different margin)
    return this.alignmentCentered ? 'mb-[14vw] md:mb-32' : 'mb-[14vw] md:mb-16'
  }
}
